import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static readonly targets = ['input', 'display'];

  declare inputTarget: HTMLTextAreaElement;
  declare displayTarget: HTMLElement;

  private get max() {
    return Number.parseInt(
      this.inputTarget.getAttribute('maxlength') ?? '0',
      10,
    );
  }

  initialize() {
    this.count();
  }

  count() {
    if (this.max) {
      this.displayTarget.textContent = `${this.inputTarget.value.length}/${this.max}`;
    }
  }
}
